import { Link } from "react-router-dom";
import "./Header.css";
import React, { useEffect, useState } from "react";

function Header() {
  const [small, setSmall] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setSmall(window.scrollY > 80);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`header ${small ? "small" : ""}`}>
      <div className="logo_type">
        Maryam Jariani
        <span> (BA, BSW, MSW, RSW, PhD C.)</span>
      </div>

      {/* Hamburger (mobile) */}
      <div
        className={`hamburger ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span />
        <span />
        <span />
      </div>

      <nav className={`nav ${menuOpen ? "open" : ""}`}>
        <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
        {/* <Link to="/mindful-leto-minds" onClick={() => setMenuOpen(false)}>
          Mindful Leto Minds
        </Link> */}
        <Link to="/appointment" onClick={() => setMenuOpen(false)}>
         Client Appointment
        </Link>
        <Link to="/appointment_referral" onClick={() => setMenuOpen(false)}>
         Doctor / Referrer
        </Link>
      </nav>
    </header>
  );
}

export default Header;
